var map = {
	"./Arrow_Close.svg": "6679",
	"./Arrow_Next_Dark.svg": "4a2e",
	"./Arrow_Next_Light.svg": "9116",
	"./Arrow_Open.svg": "368f",
	"./Background_Recruit.png": "5658",
	"./Button_Link.png": "36dc",
	"./Button_Link_hover.png": "ed6d",
	"./about/advanced_enterprise.png": "f397",
	"./about/ifs_en.png": "5213",
	"./about/ifs_zh.png": "2592",
	"./about/robot.png": "fac2",
	"./about/specialize.png": "a6b8",
	"./about/technology_enterprise.png": "a3fe",
	"./arrow_works_left.svg": "3f79",
	"./arrow_works_right.svg": "fec1",
	"./badge_appstore@3x.png": "7f05",
	"./badge_googleplay@3x.png": "f103",
	"./button_close.svg": "4e2a",
	"./button_open.svg": "360f",
	"./cooperate_logo.svg": "94ff",
	"./cooperate_logo_1.png": "df34",
	"./coordinate@3x.png": "8ab2",
	"./coordinate_big@3x.png": "7e9e",
	"./deep-robot-logo.png": "04f2",
	"./dot.svg": "de15",
	"./external_link_icon.svg": "96af",
	"./facebook@2x.png": "2735",
	"./facebook@3x.png": "4151",
	"./fenrir_logo.svg": "3097",
	"./first_view_arrow.svg": "ce4e7",
	"./icn_App.png": "182e",
	"./icn_App@3x.png": "3aa7",
	"./icn_VR.png": "dcfb",
	"./icn_VR@3x.png": "094a",
	"./icn_check.png": "3fe1",
	"./icn_check@2x.png": "d508",
	"./icn_check@3x.png": "f811",
	"./icn_consulting.png": "a3c3",
	"./icn_consulting@3x.png": "12cc",
	"./icn_design.png": "8944",
	"./icn_design@3x.png": "9414",
	"./icn_first.svg": "ed35",
	"./icn_last.svg": "70bc",
	"./icn_left.svg": "db21",
	"./icn_miniprogram.png": "2bd6",
	"./icn_miniprogram@3x.png": "890b",
	"./icn_right.svg": "cc65",
	"./icn_tool.png": "d065",
	"./icn_tool@3x.png": "d932",
	"./icon_+.png": "e20d",
	"./icon_mail.png": "9287",
	"./icon_tel.png": "8852",
	"./icon_x.png": "c0df",
	"./ifs-logo.png": "7280",
	"./ifs/aerospace.svg": "b024",
	"./ifs/bg-pc.png": "e540",
	"./ifs/bg-sp.png": "f9a5",
	"./ifs/energy.svg": "48e2",
	"./ifs/engineering.svg": "4004",
	"./ifs/partner.png": "1cb7",
	"./ifs/telecommunications.svg": "c7c7",
	"./ifs/transportation.svg": "79ef",
	"./ifs/user.svg": "ff12",
	"./ifs/vector.svg": "3bb6",
	"./img_map_pc@3x.png": "918e",
	"./img_map_sp@3x.png": "dd92",
	"./ise-woa/Flow_ISE@3x.png": "9268",
	"./ise-woa/Title_ISE1.png": "a34d",
	"./ise-woa/Title_ISE2.png": "680a",
	"./ise-woa/detail.png": "9615",
	"./kovax-miniapp/Flow_KOVAX@3x.png": "e83f",
	"./kovax-miniapp/Title_KOVAX1.png": "2cb3",
	"./kovax-miniapp/Title_KOVAX2.png": "e215",
	"./kovax-miniapp/detail.png": "7c15",
	"./kuraray-dx/Flow_kuraray_CN@3x.png": "048d",
	"./kuraray-dx/Flow_kuraray_JP@3x.png": "cae8",
	"./kuraray-dx/Minister.jpg": "249b",
	"./kuraray-dx/Title_kuraray1.png": "0b48",
	"./kuraray-dx/Title_kuraray2.png": "71b9",
	"./kuraray-dx/kuraray_PPT1_CN.jpg": "da37",
	"./kuraray-dx/kuraray_PPT1_JP.jpg": "1738",
	"./kuraray-dx/kuraray_PPT2_CN.jpg": "4810",
	"./kuraray-dx/kuraray_PPT2_JP.jpg": "13a3",
	"./kuraray-dx/kuraray_corporate_logo_rgb.svg": "ecca",
	"./line.svg": "5fed",
	"./nav/chevron-down.svg": "87a5",
	"./nav/close.svg": "a6d5",
	"./nav/menu.svg": "f1e0",
	"./new-pages/Management_PC_CN@3x.png": "6a07",
	"./new-pages/Management_PC_JP@3x.png": "30a6",
	"./new-pages/Network_Security@3x.png": "d5b8",
	"./new-pages/Network_Security_Table_CN@4x.png": "8f57",
	"./new-pages/Network_Security_Table_JP@4x.png": "15a0",
	"./new-pages/PC_CN.svg": "886b",
	"./new-pages/PC_JP.svg": "fe64",
	"./new-pages/SP_CN.svg": "79aa",
	"./new-pages/SP_JP.svg": "c936",
	"./new-pages/Security1_CN@3x.png": "3124",
	"./new-pages/Security1_JP@3x.png": "4433",
	"./new-pages/Security2_CN@3x.png": "2313",
	"./new-pages/Security2_JP@3x.png": "98b2",
	"./new-pages/Security3_CN@3x.png": "9ac4",
	"./new-pages/Security3_JP@3x.png": "1fa4",
	"./new-pages/Security4_CN@3x.png": "323e",
	"./new-pages/Security4_JP@3x.png": "8a70",
	"./new-pages/Technology_PC_CN@3x.png": "99f3",
	"./new-pages/Technology_PC_JP@3x.png": "da37b",
	"./new-pages/Title_Security_CN.png": "8b6f",
	"./new-pages/Title_Security_JP.png": "fe91",
	"./new-pages/Yostar@4x.png": "d75f",
	"./new-pages/Yostar_Alibaba_Logo@3x.png": "84b0",
	"./new-pages/Yostar_Logo@2x.png": "e9b1",
	"./new-pages/Yostar_User@2x.png": "c612",
	"./new-pages/Yostar_Websit_Bg@3x.png": "9636",
	"./new-pages/new_20231205_01.png": "1cd7",
	"./new-pages/new_20231205_02.png": "e5e7",
	"./office/cd_1021.jpg": "ffa6",
	"./office/dl_1109_1.jpg": "fb86",
	"./office/dl_1109_2.jpg": "f56f",
	"./office/sh_0924.jpg": "020f",
	"./office/sh_260410_1.jpg": "5d63",
	"./office/sh_260410_2.jpg": "4fd9",
	"./official_accounts_website_1.png": "8cc0",
	"./official_accounts_website_2.png": "6dab",
	"./official_accounts_website_3.png": "0498",
	"./official_accounts_website_qrcode.png": "b16f",
	"./omission.svg": "610c",
	"./overseas-business-wechat-official-accounts_1.png": "c0fd",
	"./overseas-business-wechat-official-accounts_2.png": "f6b6",
	"./overseas-business-wechat-official-accounts_3.png": "fe09",
	"./overseas-business-wechat-official-accounts_4.png": "22c5",
	"./overseas-business-wechat-official-accounts_qrcode.png": "d4f5",
	"./services/icons/arrow-right.svg": "fa96",
	"./services/icons/database.svg": "0706",
	"./services/icons/ifs_partner.png": "9de6",
	"./services/icons/message-square.svg": "5f0a",
	"./services/icons/pencil.svg": "2c01",
	"./services/icons/robot.svg": "bb6b",
	"./services/icons/system-integration.svg": "56c3",
	"./shadow_left.png": "8353",
	"./shadow_right.png": "a680",
	"./si/images/hero-ai.jpg": "34fb",
	"./si/images/hero-eam.jpg": "954b",
	"./si/images/hero-erp.jpg": "500e",
	"./si/images/hero-mes.jpg": "7094",
	"./si/images/hero-robot.png": "048a",
	"./si/images/hero-wms.jpg": "35c0",
	"./si/images/iot-scene-construction.png": "6284",
	"./si/images/iot-scene-factory.png": "757d",
	"./si/images/iot-scene-hazard.png": "4cae",
	"./si/images/iot-scene-remote.png": "25bc",
	"./si/images/iot-scene-security.png": "05f4",
	"./si/images/iot-scene-warehouse.png": "8fd3",
	"./si/si-icons/alert-triangle.svg": "8f25",
	"./si/si-icons/arrow-left-right.svg": "3e39",
	"./si/si-icons/arrow-right.svg": "f990",
	"./si/si-icons/award-blue.svg": "8bd7",
	"./si/si-icons/award.svg": "719f",
	"./si/si-icons/bar-chart-3.svg": "fa05",
	"./si/si-icons/bot.svg": "1c1f",
	"./si/si-icons/brain.svg": "2498",
	"./si/si-icons/building-2.svg": "4b40",
	"./si/si-icons/calendar.svg": "48f3",
	"./si/si-icons/car.svg": "1b81",
	"./si/si-icons/circuit-board.svg": "ccad",
	"./si/si-icons/clipboard-check.svg": "05d7",
	"./si/si-icons/clipboard-list.svg": "8f82",
	"./si/si-icons/clock-blue.svg": "9bb9",
	"./si/si-icons/clock.svg": "1389",
	"./si/si-icons/cpu.svg": "ad35",
	"./si/si-icons/database.svg": "7ca2",
	"./si/si-icons/dollar-sign.svg": "4d3b",
	"./si/si-icons/eye.svg": "0f8d",
	"./si/si-icons/factory.svg": "c0e7",
	"./si/si-icons/file-check.svg": "ba91",
	"./si/si-icons/file-text.svg": "1b08",
	"./si/si-icons/flask-conical.svg": "b105",
	"./si/si-icons/gauge-blue.svg": "3591",
	"./si/si-icons/gauge.svg": "e1d7",
	"./si/si-icons/globe.svg": "f47f",
	"./si/si-icons/heart-pulse.svg": "6276",
	"./si/si-icons/landmark.svg": "732c",
	"./si/si-icons/layers-3.svg": "a727",
	"./si/si-icons/message-square.svg": "9bf7",
	"./si/si-icons/package.svg": "c12c",
	"./si/si-icons/pencil.svg": "26f2",
	"./si/si-icons/pill.svg": "5ca7",
	"./si/si-icons/qr-code.svg": "4ecd",
	"./si/si-icons/route.svg": "cf36",
	"./si/si-icons/search.svg": "b190",
	"./si/si-icons/server.svg": "c5f7",
	"./si/si-icons/shield-check.svg": "3596",
	"./si/si-icons/shield.svg": "04d3",
	"./si/si-icons/shopping-bag.svg": "43b72",
	"./si/si-icons/shopping-basket.svg": "793f",
	"./si/si-icons/shopping-cart.svg": "4b405",
	"./si/si-icons/smartphone.svg": "8492",
	"./si/si-icons/sparkles.svg": "67b6",
	"./si/si-icons/store.svg": "fe62",
	"./si/si-icons/thermometer.svg": "d1be",
	"./si/si-icons/train.svg": "b27d",
	"./si/si-icons/trending-down-blue.svg": "018e",
	"./si/si-icons/trending-down.svg": "7cfb",
	"./si/si-icons/trending-up.svg": "eef2",
	"./si/si-icons/users.svg": "e47f",
	"./si/si-icons/utensils-crossed.svg": "c1b6",
	"./si/si-icons/warehouse.svg": "d8b0",
	"./si/si-icons/wrench.svg": "a32b",
	"./si/si-icons/zap.svg": "3e21",
	"./square.jpg": "b5d4",
	"./twitter.svg": "a3df",
	"./uiux/aerospace.svg": "df7b",
	"./uiux/consumer.svg": "ac06",
	"./uiux/defense.svg": "e7eb",
	"./uiux/hotel.svg": "c135",
	"./uiux/manufacturing.svg": "9a71",
	"./uiux/medal.svg": "1a4f",
	"./uiux/profile.svg": "7235",
	"./uiux/shopping-cart.svg": "d0db",
	"./uiux/utilities.svg": "d751",
	"./wechat@2x.png": "3807",
	"./wechat@3x.png": "927d",
	"./wechat_code.jpg": "5678",
	"./weibo@2x.png": "fd83",
	"./weibo@3x.png": "c73c",
	"./works_beijing_xikemu_1.png": "0a59",
	"./works_beijing_xikemu_2.png": "0398",
	"./works_beijing_xikemu_3.jpg": "2f46",
	"./works_beijing_xikemu_4.jpg": "c894",
	"./works_beijing_xikemu_5.jpg": "b45d",
	"./works_beijing_xikemu_6.jpg": "85b5",
	"./works_beijing_xikemu_7.jpg": "d56c",
	"./works_feilang_go_1.png": "5bda",
	"./works_feilang_go_2.png": "6af6",
	"./works_feilang_go_3.png": "5781",
	"./works_feilang_go_4.png": "7c91",
	"./works_kuraray_miniapp_1.png": "e4b4",
	"./works_kuraray_miniapp_2.png": "ad95",
	"./works_kuraray_miniapp_3@1x.png": "0529",
	"./works_kuraray_miniapp_3@2x.png": "454c",
	"./works_kuraray_miniapp_3@3x.png": "aa4f",
	"./works_kuraray_miniapp_4@1x.png": "14b0",
	"./works_kuraray_miniapp_4@2x.png": "6a92",
	"./works_kuraray_miniapp_4@3x.png": "18c7",
	"./works_kuraray_miniapp_5.jpg": "1cf1",
	"./works_kuraray_miniapp_6.jpg": "017b",
	"./works_mixi_xflag_1.png": "1116",
	"./works_mixi_xflag_2.png": "66ee",
	"./works_mixi_xflag_3.png": "7790",
	"./works_mixi_xflag_4.png": "c42e",
	"./works_nikkei_telecon_1.png": "8762",
	"./works_nikkei_telecon_2.png": "d6ef",
	"./works_nikkei_telecon_3.png": "dd40",
	"./works_nikkei_telecon_4.png": "8530",
	"./works_procurement_system_app_1.png": "1ca3",
	"./works_procurement_system_app_2.png": "c4a2",
	"./works_procurement_system_app_2@4x.png": "31a1",
	"./works_rakuten_gora_1.png": "caa6",
	"./works_rakuten_gora_2.png": "18fa",
	"./works_rakuten_gora_3.png": "8b51",
	"./works_rakuten_gora_4.png": "3071",
	"./works_subway_mobile_app_1.png": "73b6",
	"./works_subway_mobile_app_2.png": "243d",
	"./works_subway_mobile_app_3.png": "1a27",
	"./works_wechat_anpi_1.png": "a38e",
	"./works_wechat_anpi_2.png": "a018",
	"./works_wechat_anpi_3.png": "acfd",
	"./works_wechat_anpi_4.png": "218a",
	"./works_xikemu_dx_1.png": "fa44",
	"./works_xikemu_dx_2.png": "2177",
	"./works_xikemu_dx_3.jpg": "73e7",
	"./works_xikemu_dx_4.jpg": "1b86",
	"./works_xikemu_dx_5.jpg": "e8d3",
	"./works_xikemu_dx_6.jpg": "c565",
	"./works_xikemu_dx_7.jpg": "becb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";